import styled from "styled-components";

export const HomePageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    
    .accordion-container {
        /* background-color: var(--theme-color-tertiary); */
        border: 1px solid var(--border-color);
        border-radius: 6px !important;
        box-shadow: none;
        overflow: hidden;
    }

    .accordion-head {
        background-color: var(--theme-color-seventh);
        min-height: 56px;

        span {
            margin: 0;
        }

        .accordion-icon {
            width: 20px;
            height: auto;
            color: var(--theme-color-sixth);
            margin-right: 10px;
        }

        .accordion-label {
            font-size: 18px;
            color: var(--text-color-primary);
        }
    }

    .accordion-body {
        background-color: var(--theme-color-secondary);
        border-top: 1px solid var(--table-border-color);
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 16px;
        padding: 20px 16px;

        @media only screen and (max-width: 1280px) {
            grid-template-columns: repeat(3, minmax(0, 1fr));
        }

        @media only screen and (max-width: 900px) {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }

        @media only screen and (max-width: 600px) {
            grid-template-columns: repeat(1, minmax(0, 1fr));
        }
    }

    .css-1808mag-MuiPaper-root-MuiAccordion-root.Mui-expanded {
        margin: 0;
    }

    .css-1f1pi2l-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded {
        min-height: 56px;
    }
`;

export const AccordionCard = styled.div`
    display: flex;
    /* flex-wrap: wrap; */
    align-items: center;
    gap: 12px;
    padding: 18px;
    background-color: var(--theme-color-secondary);
    border: 1px solid var(--border-color);
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.4s ease-in-out;

    .left {
        display: flex;

        svg {
            width: 26px;
            height: auto;
            color: var(--theme-color-primary);
            transition: all 0.4s ease-in-out;
        }
    }

    .right {
        display: flex;
        flex-direction: column;
        gap: 4px;

        h6 {
            text-transform: capitalize;
            transition: all 0.4s ease-in-out;
        }

        p {
            font-size: 10px;
            margin: 0;
            transition: all 0.4s ease-in-out;
        }
    }

    &:hover {
        background-color: var(--theme-color-primary);
        transform: scale(1.05);
        
        .left {
            svg {
                color: var(--theme-color-white);
            }
        }

        .right {
            h6 {
                color: var(--theme-color-white);
            }

            p {
                color: var(--theme-color-white);
            }
        }
    }
`;